import { all, takeEvery, fork, call, put } from "redux-saga/effects";
import { tllBulkReservationSettingService } from "@iso/services";
import actions from "./actions";

function* listSettings() {
  yield takeEvery(actions.LIST_REQUEST, function* ({ payload }) {
    const { resolve, reject } = payload || {};
    try {
      const response = yield call(tllBulkReservationSettingService.list);
      const items = Array.isArray(response) ? response : [];
      yield put({ type: actions.LIST_SUCCESS, items });
      resolve && resolve(items);
    } catch (error) {
      yield put({ type: actions.LIST_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* searchSettings() {
  yield takeEvery(actions.SEARCH_REQUEST, function* ({ payload }) {
    const {
      keyword,
      executionType,
      isActive,
      latestStatus,
      page,
      size,
      resolve,
      reject,
    } = payload || {};
    try {
      const response = yield call(tllBulkReservationSettingService.search, {
        keyword,
        executionType,
        isActive,
        latestStatus,
        page,
        size,
      });
      resolve && resolve(response);
      const rawItems =
        response?.items ?? (Array.isArray(response) ? response : null);
      const items = Array.isArray(rawItems) ? rawItems : [];
      const total = Number(response?.total);
      yield put({
        type: actions.SEARCH_SUCCESS,
        items,
        total: Number.isFinite(total) ? total : 0,
      });
    } catch (error) {
      yield put({ type: actions.SEARCH_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* createSetting() {
  yield takeEvery(actions.CREATE_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(tllBulkReservationSettingService.create, data);
      yield put({ type: actions.CREATE_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.CREATE_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* getSettingDetail() {
  yield takeEvery(actions.DETAIL_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(tllBulkReservationSettingService.getDetail, {
        batchCrawlSettingId,
      });
      yield put({ type: actions.DETAIL_SUCCESS, detail: response });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.DETAIL_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* updateSetting() {
  yield takeEvery(actions.UPDATE_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, data, resolve, reject } = payload;
    try {
      const response = yield call(tllBulkReservationSettingService.update, {
        batchCrawlSettingId,
        data,
      });
      yield put({ type: actions.UPDATE_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.UPDATE_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* deleteSetting() {
  yield takeEvery(actions.DELETE_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(tllBulkReservationSettingService.delete, {
        batchCrawlSettingId,
      });
      yield put({ type: actions.DELETE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.DELETE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* executeSetting() {
  yield takeEvery(actions.EXECUTE_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(tllBulkReservationSettingService.execute, {
        batchCrawlSettingId,
      });
      yield put({ type: actions.EXECUTE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.EXECUTE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* cancelSetting() {
  yield takeEvery(actions.CANCEL_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload;
    try {
      const response = yield call(tllBulkReservationSettingService.cancel, {
        batchCrawlSettingId,
      });
      yield put({ type: actions.CANCEL_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.CANCEL_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* getCurrent() {
  yield takeEvery(actions.CURRENT_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload || {};
    try {
      const response = yield call(tllBulkReservationSettingService.getCurrent, {
        batchCrawlSettingId,
      });
      yield put({ type: actions.CURRENT_SUCCESS, current: response });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.CURRENT_ERROR });
      reject && reject(error);
    }
  });
}

function* getHistories() {
  yield takeEvery(actions.HISTORIES_REQUEST, function* ({ payload }) {
    const { batchCrawlSettingId, resolve, reject } = payload || {};
    try {
      const response = yield call(tllBulkReservationSettingService.getHistories, {
        batchCrawlSettingId,
      });
      const raw = response?.histories ?? response ?? [];
      const histories = Array.isArray(raw) ? raw : [];
      yield put({ type: actions.HISTORIES_SUCCESS, histories });
      resolve && resolve(histories);
    } catch (error) {
      yield put({ type: actions.HISTORIES_ERROR });
      reject && reject(error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(listSettings),
    fork(searchSettings),
    fork(createSetting),
    fork(getSettingDetail),
    fork(updateSetting),
    fork(deleteSetting),
    fork(executeSetting),
    fork(cancelSetting),
    fork(getCurrent),
    fork(getHistories),
  ]);
}
